/**
 * Χρώμα κατηγορίας / προϊόντος στον κατάλογο (απόφαση ιδιοκτήτη 12/10/2026, migration 264,
 * backend utils/catalogColors.js — ίδια λίστα, ίδια σειρά· το ελέγχει το tests/catalogColors.test.js).
 *
 * Κλειστή παλέτα, όχι ελεύθερο χρώμα: οι 17 τόνοι του ταμείου, οι ίδιοι που βγάζει ο αυτόματος
 * κανόνας (catalogHelpers.getCategoryColor) και που ζωγραφίζει το CashierV2.css από το ΙΔΙΟ
 * --tone-h/--tone-s σε ανοιχτό και σκούρο (§4 κουτιά κατηγοριών, §5 κάρτες προϊόντων).
 *   null = κατηγορία «Αυτόματο» (από το όνομα, όπως ως σήμερα) · προϊόν «Χωρίς».
 */
export const CATALOG_TONES = [
  'slate', 'red', 'orange', 'amber', 'yellow', 'lime', 'emerald', 'teal', 'cyan',
  'sky', 'blue', 'indigo', 'violet', 'purple', 'fuchsia', 'pink', 'rose',
] as const;

export type CatalogTone = typeof CATALOG_TONES[number];

/** Έγκυρος τόνος ή null — ό,τι άλλο (κενό, άγνωστη τιμή, παλιό backend χωρίς το πεδίο) = δεν ορίστηκε. */
export function catalogTone(value: unknown): CatalogTone | null {
  return typeof value === 'string' && (CATALOG_TONES as readonly string[]).includes(value)
    ? (value as CatalogTone)
    : null;
}
